jQuery(($) => {
    console.log('Custom block scripts loaded');
})